import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'

export default class RexReadAloudStudentController extends Controller {
  queryParams = ['sort', 'pageNumber', 'perPage']

  @tracked sort = '-created_at'

  @tracked pageNumber = 1

  @tracked perPage = 10
}

declare module '@ember/controller' {
  interface Registry {
    'reporting/ui-scope/rex/read-aloud-fluency/student': RexReadAloudStudentController
  }
}
